/**
 * Rasterize a typed signature to a PNG data URL in the signer's cursive
 * display font (already loaded on the page via Google Fonts). 3x scale for
 * crisp stamping into the PDF signature box; ink-blue to read as a signature.
 * The server-side PDF renderer has no cursive font, so without this image the
 * fax shows the name in plain Helvetica instead of the script the signer saw.
 */
export function typedSignatureToPng(name: string, font: string): string | null {
  if (!name) return null;
  try {
    const scale = 3;
    const fontPx = 44;
    const probe = document.createElement("canvas").getContext("2d") as CanvasRenderingContext2D;
    probe.font = `${fontPx}px '${font}', cursive`;
    const textW = Math.ceil(probe.measureText(name).width);
    const canvas = document.createElement("canvas");
    canvas.width = (textW + 32) * scale;
    canvas.height = Math.ceil(fontPx * 1.6) * scale;
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    ctx.scale(scale, scale);
    ctx.font = `${fontPx}px '${font}', cursive`;
    ctx.fillStyle = "#1a2a6e";
    ctx.textBaseline = "middle";
    ctx.fillText(name, 16, (fontPx * 1.6) / 2);
    return canvas.toDataURL("image/png");
  } catch {
    return null; // fall back to the typed-name path server-side
  }
}
